import { useMemo } from 'react';
import {
  GetStartEndSettingsDocument,
  GetStartEndSettingsQuery,
  GetStartEndSettingsQueryVariables
} from 'graphql/types';
import usePersistedCacheQuery from 'modules/common/hooks/usePersistedCacheQuery';

export const useStartEndSettings = (): {
  data: GetStartEndSettingsQuery | undefined;
  loading: boolean;
} => {
  const { loading, data } = usePersistedCacheQuery<
    GetStartEndSettingsQuery,
    GetStartEndSettingsQueryVariables
  >(GetStartEndSettingsDocument, {});

  return useMemo(
    () => ({
      loading,
      data
    }),
    [data, loading]
  );
};
